import Card from '../components/Card/Card.jsx';
import Footer from '../components/Footer/Footer.jsx';
import cor1 from '../images/Cab_photos/cor_1/IMG20250325090155.jpg'
import cor2 from '../images/Cab_photos/cor_2/IMG20250325104103.jpg'
import cor3 from '../images/Cab_photos/cor_3.1/IMG20250325110111.jpg'

function Choose_floor() {
  return (
    <div className="Choose_floor">
        <div className='cards'>
        <Card name={'1 Этаж'} img={cor1} link={'/First_floor'}/>
        <Card name={'2 Этаж'} img={cor2} link={'/Secondfloor'}/>
        <Card name={'3 Этаж'} img={cor3} link={'/Thirdfloor'}/>
        </div>
        <Footer/>
    </div>
  );
}

export default Choose_floor;
